import {createPortError} from '../platform/port-error.js';

function requireClient(client){
  if(typeof client?.rpc!=='function')throw new TypeError('Database client with rpc() is required');
  return client;
}

function smokerId(value){
  const id=String(value||'').trim();
  if(!id)throw new TypeError('smokerId is required');
  return id;
}

function version(value){
  const number=Number(value);
  if(!Number.isInteger(number)||number<1)throw createPortError('DEFAULT_SMOKER_INVALID_RESPONSE');
  return number;
}

export function mapDefaultSmokerRows(rows=[]){
  if(!Array.isArray(rows)||rows.length===0)throw createPortError('DEFAULT_SMOKER_EMPTY_RESPONSE');
  const mapped=rows.map(row=>Object.freeze({
    id:smokerId(row?.smoker_id),
    serverVersion:version(row?.smoker_version),
    isDefault:row?.default_selected===true
  }));
  if(mapped.filter(row=>row.isDefault).length!==1)throw createPortError('DEFAULT_SMOKER_INVALID_RESPONSE');
  return Object.freeze(mapped);
}

export function createSmokerDefaultRemote({client}={}){
  const db=requireClient(client);

  async function setDefault(id){
    const target=smokerId(id);
    const {data,error}=await db.rpc('set_default_smoker',{target_smoker_id:target});
    if(error)throw createPortError('DEFAULT_SMOKER_REMOTE_FAILED',{retryable:true});
    const rows=mapDefaultSmokerRows(data);
    if(!rows.some(row=>row.id===target&&row.isDefault)){
      throw createPortError('DEFAULT_SMOKER_TARGET_NOT_SELECTED');
    }
    return rows;
  }

  return Object.freeze({setDefault});
}
